import { trackFetchErrors } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { PACKAGE_NAME } from './privacyLevelPrivate.constants.tsx';
import type { SettingsGet } from './SettingsGet.types.tsx';

const key = 'announcementBannerDismissedLast';

export const get = async (accoundId: string | null): Promise<string | null> => {
	try {
		return accoundId != null
			? (
					await getUserProperty<{
						hashId: string;
					}>(accoundId, key)
				).hashId
			: null;
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 404 - property has not been previously set
		if (error.statusCode === 404) {
			return null;
		}

		trackFetchErrors({
			error,
			id: 'userDismissGet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};

export const set = async (accoundId: string, hashId: SettingsGet['hashId']): Promise<void> => {
	try {
		return await setUserProperties(accoundId, key, JSON.stringify({ hashId }));
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		trackFetchErrors({
			error,
			id: 'userDismissSet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};

export const bannerDismissalUserProperty: {
	get: (accoundId: string | null) => Promise<string | null>;
	set: (accoundId: string, hashId: SettingsGet['hashId']) => Promise<void>;
} = {
	get,
	set,
};
